module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA70lEQVR4AWMYgmAUjIL/LcLSZOn7/5/xf6eIFH5F3eLcvxu5X/xp4koiyfD9Diy/GrgX/27kWkdYcTOP5q9Grke/m7iLiDJ8vgIH0OBNQIft+D9TiovIYBKQ/9XIfet3I08LXnWdIrxAgw8A8ar/q7TZSAvTbh4xoLfP/2ngmvr/fwMThnwPrwjQp2d+NfLMQpYnzZIOQf7fDVyHgb5Z9n+mMSvC5UIyQMuv/27g7qQ8VfXJcAKDYBsQbwGx/7fxqgFd/gDIL6da0gW5Huji5UDfHAca/OxXE1ca1fMHKJyB8TH5TxNPGGk6R8EoGAUAxz9tSQqU3WYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/b1_arrow_down@2x.png
// module id = f4tx
// module chunks = 1